// Cliente HTTP del módulo /api/usuarios (Salonika backend).
import { api } from './client';
import type { ApiRol } from './auth';

export interface ApiUsuario {
  id: number;
  username: string;
  nombre: string;
  rol: ApiRol;
  sede_id: number | null;
  sede_codigo: string | null;
  sede_nombre: string | null;
  activo: boolean;
  created_at: string;
  last_login_at: string | null;
  // Contacto para notificaciones (mig. 031). whatsapp = solo dígitos con
  // indicativo país (573001234567); el backend normaliza lo que se escriba.
  email: string | null;
  whatsapp: string | null;
  notif_email: boolean;
  notif_whatsapp: boolean;
}

export interface CrearUsuarioInput {
  username: string;
  nombre: string;
  password: string;
  rol: ApiRol;
  sede_id: number | null;   // null = "Todas las sedes"
  email?: string | null;
  whatsapp?: string | null;
  notif_email?: boolean;
  notif_whatsapp?: boolean;
}

export interface EditarUsuarioInput {
  nombre?: string;
  rol?: ApiRol;
  sede_id?: number | null;
  activo?: boolean;
  password?: string;        // solo si se quiere cambiar
  email?: string | null;
  whatsapp?: string | null;
  notif_email?: boolean;
  notif_whatsapp?: boolean;
}

export const listUsuarios = () => api.get<ApiUsuario[]>('/api/usuarios');

/** Lista liviana {id, nombre} de usuarios ACTIVOS — accesible a cualquier
 *  usuario autenticado (la usan los meseros para el "A nombre de" de las
 *  cortesías; no expone username/rol/sede). */
export interface UsuarioNombre { id: number; nombre: string }
export const listUsuarioNombres = () => api.get<UsuarioNombre[]>('/api/usuarios/nombres');
export const crearUsuario = (input: CrearUsuarioInput) =>
  api.post<{ id: number }>('/api/usuarios', input);
export const editarUsuario = (id: number, input: EditarUsuarioInput) =>
  api.patch<{ ok: boolean }>(`/api/usuarios/${id}`, input);
export interface EliminarUsuarioResult {
  ok: boolean;
  eliminado?: boolean;     // true = borrado de verdad
  desactivado?: boolean;   // true = tenía historial → se desactivó en vez de borrar
  mensaje?: string;
}
// Borra el usuario (SOLO desarrollador). Si tiene historial, el backend lo
// desactiva y lo indica en la respuesta.
export const eliminarUsuario = (id: number) =>
  api.del<EliminarUsuarioResult>(`/api/usuarios/${id}`);
